<template>
  <div class="inner-layout">

    <div class="page-title">고객센터</div>

    <cs-center-tab></cs-center-tab>

    <div class="board-container">
      <div v-for="item in list" class="board-item">
        <div class="board-title-box" @click="toggle(item.idx)" :class="{ active : item.idx === selectedIdx}">
          <span v-if="item.top" class="chip chip-outline color-1">공지사항</span>
          <span class="title notice-title">{{ item.title }}</span>
          <span class="date">{{ $getDateFormat(item.createDate, 'Y.m.d') }}</span>
        </div>
        <div class="board-content-box" v-if="item.idx === selectedIdx">
          <div class="content" v-html="String(item.content).nl2br()"></div>
        </div>
      </div>
      <div v-if="!list || list.length === 0" class="noDataMessage2">{{ $msg('nodata2') }}</div>
    </div>

    <infinite-loading ref="infiniteLoading" spinner="spiral" @infinite="infiniteHandler">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
export default {
  name: "notice",
  data() {
    return {
      page: 1,
      pageSize: 20,
      list: null,
      selectedIdx: null,
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    toggle(idx) {
      if (this.selectedIdx == idx) this.selectedIdx = null
      else this.selectedIdx = idx
    },
    async infiniteHandler($state) {
      try {
        const { result, list } = await this.$api.getNoticeList({
          page: this.page,
          pageSize: this.pageSize,
        })
        if (result === 'success' && list && list.length > 0) {
          this.list = this.page == 1 ? list : this.list.concat(list)
          setTimeout(() => {
            this.page += 1;
            $state.loaded();
          }, 1000);
        }
        else {
          $state.complete();
        }
      } catch (error) {
        console.log(error);
      }
    },
  }
}
</script>
